// extracted by mini-css-extract-plugin
export default {"container":"OnboardingPageCommon_container__q6Cwv","content":"OnboardingPageCommon_content__mdoir","delimiter":"OnboardingPageCommon_delimiter__PDwaA"};